import { AfterViewInit, ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output } from '@angular/core';
import { ReplaySubject, Subject } from "rxjs";
import panzoom, { PanZoom } from 'panzoom';
import { MenuItem } from 'primeng/api';

// import { UprightRead } from 'src/client';
import { CorridorLabel } from 'src/app/models/corridor_label';
// import { SessionService } from 'src/app/services/session.service';
// import { SelectedWarehouseService } from 'src/app/services/selectedwarehouse.service';
import { AbstractTooltipable } from 'src/app/shared/directives/abstract-tooltipable.directive';
// import { RoleService } from 'src/app/services/role.service';


@Component({
  selector: 'app-svg-map',
  templateUrl: './svg-map.component.html',
  styleUrls: ['./svg-map.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SvgMapComponent extends AbstractTooltipable implements OnChanges, OnInit, OnDestroy, AfterViewInit {

  @Input() identifier: string = "default";
  @Input() svgStyle: string = "";

  @Input() uprights: Array<any> = [];
  @Input() verticalCorridorsColumns: number[] = []
  @Input() horizontalCorridorsRows: number[] = []
  @Input() corridorLabels: CorridorLabel[] = []
  private prevUprights: Array<any> = [];
  @Input() centerOn: any | undefined;
  @Input() getClassForStyle: (upright: any) => string = (_) => "";
  @Input() isClickable: (upright: any) => boolean = (_) => false;
  @Input() hasNewNotifications: (upright: any) => boolean = (_) => false;
  @Input() handleOpenContextMenu: (event: MouseEvent, upright: any) => MenuItem[] =
    (_1: MouseEvent, _2: any) => this.menuItems;
  @Output() onClick = new EventEmitter<any>();

  @Input() menuItems: MenuItem[] = [];
  @Input() isLoading: boolean = false;
  @Input() focusedUprightsIDs: string[] = [];
  private htmlNodesToDeleteOnChanges: Array<Node> = [];

  dim = 100;
  separation = 20;
  total_dim = this.dim + this.separation;
 

  arr_like_rows: Array<number> = [];
  arr_like_columns: Array<number> = [];

  initialZoom = 0.3;
  detailZoom = 0.1;
  private pZoom: PanZoom = {} as PanZoom;
  private panzoomCoords: Subject<[number, number, number]> = new ReplaySubject<[number, number, number]>(1);
  private mousePosition = {
    x: 0, y: 0
  };


  constructor(
    // private sessionService: SessionService,
    // private roleService: RoleService,
    // private selectedWarehouseService: SelectedWarehouseService
  ) {
    super();
  }

  public ngOnInit(): void {
    
    
    // this.selectedWarehouseService.selectedSection$.subscribe((section) => {
    //   this.verticalCorridorsColumns =
    //     section?.corridors?.['verticalCorridorsColumns'] ?? [];

    //   this.horizontalCorridorsRows =
    //     section?.corridors?.['horizontalCorridorsRows'] ?? [];

    //   this.corridorLabels =
    //     section?.corridors?.['labels'] ?? [];
    // });
  }

  ngAfterViewInit() {
    this.pZoom = panzoom(document.getElementById(['drag_root_', this.identifier].join(''))!, {
      maxZoom: 2,
      minZoom: 0.05,
      initialZoom: this.initialZoom,
      smoothScroll: false,
      initialX: 0,
      initialY: 0,
      beforeWheel: function (e) {
        // Allow wheel zoom only when altKey is pressed, otherwise regular scroll
        let shouldIgnore = !e.altKey;
        return shouldIgnore;
      }
    });

    this.pZoom.on('touchEnd', (event) => {
      console.log('panzoomend', event);
    });


    this.centerSVG(this.centerOn);
  }

  public ngOnChanges(): void {
    if (this.isLoading) {
      this.htmlNodesToDeleteOnChanges.forEach((node: Node) => {
        this.htmlNodesToDeleteOnChanges.pop();
        node.textContent = '';
      });
    }

    if (this.uprights.length == 0) {
      return;
    }

    const max_row = this.uprights.map(s => s.x_position).sort((a, b) => a - b).pop();
    this.arr_like_rows = Array(max_row).fill(0);

    const max_col = this.uprights.map(s => s.y_position).sort((a, b) => a - b).pop();
    this.arr_like_columns = Array(max_col).fill(0);

    // Center SVG just if new map is loaded
    if (this.uprights.length !== this.prevUprights.length) {
      this.centerSVG(this.centerOn);
      this.prevUprights = this.uprights;
    }

    // 0 ms timeout to wait for the DOM to be updated
    let that = this;
    setTimeout(function () { that.highlightHoveredUprights(); }, 0);
  }

  private highlightHoveredUprights(): void {
    this.focusedUprightsIDs.forEach((id: string) => {
      try {
        let hoveredUprightElement = document.getElementById(`upright-${id}-${this.identifier}`);
        let a = document.getElementById(`upright-container-${this.identifier}`)?.appendChild(hoveredUprightElement! as Node);
        if (a) {
          this.htmlNodesToDeleteOnChanges.push(a);
        }
      } catch (e) {
        console.error(e);
      }
    });

    let firstFocusedUpright = this.uprights.find((p: any) => p.id === this.focusedUprightsIDs[0]);
    if (firstFocusedUpright) {
      let svg = document.getElementById(`svg-map-${this.identifier}`)!.getBoundingClientRect();
      let xCoord = this.getXCoord(firstFocusedUpright.y_position) * this.pZoom.getTransform().scale;
      let yCoord = this.getYCoord(firstFocusedUpright.x_position) * this.pZoom.getTransform().scale;
      this.pZoom.smoothMoveTo(-xCoord + svg.width / 2, -yCoord + svg.height / 3);
    }
  }

  public getUprightAt(x: number, y: number): any | undefined {
    return this.uprights.find(s => s.x_position === x && s.y_position == y);
  }

  public handleUprightMouseDown(event: MouseEvent): void {
    this.mousePosition = { x: event.clientX, y: event.clientY };
  }

  public handleUprightClick(upright: any, event: MouseEvent): void {
    if (this.mousePosition.x === event.clientX && this.mousePosition.y === event.clientY) {
      this.onClick.emit(upright);
    }
  }

  public getXCoord(column: number): number {
    return (column - 1) * this.total_dim;
  }

  public getYCoord(row: number): number {
    return (row - 1) * this.total_dim;
  }

  public getDisplayName(upright: any): string {
    if (this.getClassForStyle(upright) === "DRAFT") {
      // return "PERDIDA";
      return upright.public_id;
    } else if (this.getClassForStyle(upright) === "OFF") {
      return "OFF";
    } else if (upright.public_id && upright.public_id.length > 0) {
      return upright.public_id;
    }
    return '';
  }

  public uprightHasCorridor(position: string, column: number, row: number): boolean {
    switch (position.toLowerCase()) {
      case 'top':
        if (this.uprights.find(p => p.y_position === column && p.x_position === row - 1)) {
          return false;
        }
        return this.horizontalCorridorsRows.includes(row - 1);

      case 'right':
        if (this.uprights.find(p => p.y_position === column + 1 && p.x_position === row)) {
          return false;
        }
        return this.verticalCorridorsColumns.includes(column + 1);

      case 'bottom':
        if (this.uprights.find(p => p.y_position === column && p.x_position === row + 1)) {
          return false;
        }
        return this.horizontalCorridorsRows.includes(row + 1);

      case 'left':
        if (this.uprights.find(p => p.y_position === column - 1 && p.x_position === row)) {
          return false;
        }
        return this.verticalCorridorsColumns.includes(column - 1);
      default:
        return false;
    }
  }

  public isManager(): boolean {
    // return this.roleService.isManager() && !this.sessionService.isAdminVisualizerMode();
    return true;
  }

  public centerSVG(centerOn?: any): void {
    if (!this.pZoom)
      return;

    this.panzoomCoords.subscribe(([xCoord, yCoord, zoom]) => {
      this.pZoom.centerOn;
      this.pZoom.zoomAbs(xCoord, yCoord, zoom);
      this.pZoom.moveTo(xCoord + 50, yCoord + 10);
    });

    if (centerOn) {
      let svg = document.getElementById(`svg-map-${this.identifier}`)!.getBoundingClientRect();
      let xCoord = this.getXCoord(centerOn.y_position) * this.detailZoom;
      let yCoord = this.getYCoord(centerOn.x_position) * this.detailZoom;
      this.panzoomCoords.next([-xCoord + svg.width / 3, -yCoord + svg.height / 3, this.detailZoom]);
    } else {
      let svgWidth = document.getElementById(`svg-map-${this.identifier}`)!.getBoundingClientRect().width;
      let maxYPosition = this.uprights.map(s => s.y_position).sort((a, b) => a - b).pop();
      let mapWidth = maxYPosition ? ((maxYPosition + 1) * this.total_dim) : 0;

      let xCoord = svgWidth / 2 - (mapWidth / 2) * this.initialZoom;
      this.panzoomCoords.next([xCoord, 25, this.initialZoom]);
    }
  }

  public zoomInSVG(): void {
    let tr = this.pZoom.getTransform();
    this.pZoom.zoomAbs(tr.x, tr.y, tr.scale * 1.5);
  }

  public zoomOutSVG(): void {
    let tr = this.pZoom.getTransform();
    this.pZoom.zoomAbs(tr.x, tr.y, tr.scale / 1.5);
  }

  public ngOnDestroy(): void {
    document.getElementById(['drag_root_', this.identifier].join(''))?.remove();
  }
}